import { initMultipleSlider } from 'application/shared/sliders';
import { createLeadAssistant } from '@quero/qb-partials/src/javascripts/components/lead_assistant';
import CanonicalCourseSelector from 'application/shared/canonical_course_selector';

const $canonicalSelector = $('.js-canonical-selector').prop('disabled', false);
CanonicalCourseSelector($canonicalSelector);

initMultipleSlider();
createLeadAssistant();
